import mitt from 'mitt';
import { btnTd } from '@/api/typing';
import { message, Modal } from 'ant-design-vue';
import defaultSlotList from '@/components/page-model/slotList';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import { delete_request_order } from '@/api/jms-model.ts';

export const event_obj = mitt();
export const btn_list = [
  {
    name: '取消',
    clazz: 'danger',
    is_show: (record: any) => {
      return record.status == 0;
    },
    cb: (data: any) => {
      // 模态框，确认按钮点击。
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      Modal.confirm({
        title: '提示',
        content: '是否取消报单？',
        onOk() {
          // todo: 创建合同的模态框
          // todo: 此处创建合同时，顾问要用input，防止多查数据，导致网络缓慢
          delete_request_order({ org_id: current_org.id, requestorder_id: data.id }).then(
            function () {
              message.success('取消成功');
              event_obj.emit('refresh');
            },
          );
        },
        onCancel() {},
      });
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list: btnTd[] = [];
